
import {Link} from "react-router-dom";
import "../components/game-board-activities/GameBoardActivities/gameBoardActivities.css";
import "../components/game-board-activities/GameBoardActivities/gameBoardActivitiesMedia.css";
import React from 'react';
import { connect } from 'react-redux';
import {Tooltip} from "@mui/material";
import withRouterCompat from "../objects/CommonUse/with_router_compat";
import LinkTab from '../components/shared-components/link_tab';
//import {InputCompletedContext} from '../objects/Context/input_completed_context';
import SelectActivity from '../components/game-board-activities/select_activity';
import SelectFriendForActivity from '../components/game-board-activities/select_friend_for_activity';
import StartActivity from '../components/game-board-activities/start_activity';
import FinishActivity from "../components/game-board-activities/finish_activity";
import CommentModal from '../components/shared-components/comment_modal';
import { setHeadersForFetch } from '../objects/CommonUse/set_headers_for_fetch';
import {buildUrl } from '../objects/CommonUse/build_URL';
import Config from '../config';
import Footer from "./footer";
import tooltipCommentIconText from "./Text/tooltip_text";


// mapStateToProps: pick the Redux state your component needs
const mapStateToProps = (state) => ({
    activityCategory: state.activityCategory,
});

class Activities extends React.Component {
    constructor(props) {
        super(props);
                       
     this.openCommentModal = this.openCommentModal.bind(this);
     this.closeCommentModal = this.closeCommentModal.bind(this);
     this.state = {
        inputArr: [
            {
                completed: false,
                selected: false
            },
            {
                completed: false,
                selected: false
            },
            {
                completed: false,
                selected: false
            },
            {
                completed: false,
                selected: false
            },
           
        ],
        activityCategory: "",
        commentIcon: "./assets/ContactUs/pencilPaper.png",
        commentModalOpen: false,
        fromProcessName: "Activities",
        screenSize: sessionStorage.getItem("GameScreenSize"),
        headers: setHeadersForFetch(),
        environment: Config.dataURL.currentEnv,
        subProcess: "ActivitiesMain",
        activityInfo: {
            loadingGame: true,
            slctActivity: {},
            friendInfo: {},
            activityStarted: false,
            activityScore: {},
            activityTracker: "",
            addActivityTracker: false,
            slctCategory: "",
            activityCategory: "",
            creditCardInfo: {}
        }
    };

    switch(props.selected) {
        case "selectActivity":
            this.inputSelected(0);
            break;
        case "chooseAFriend":
            this.inputSelected(1);
             break;
        case "startActivity":
            this.inputSelected(2);
            break;
        case "finishActivity":
            this.inputSelected(3);
            break;
        default:
            break;
    }
    this.initializeActivityInfo();
};
    initializeActivityInfo(){
        const activityCategoryInfo = this.props.activityCategory;
        const activityCategory = activityCategoryInfo.detail;
        this.setActivityInfo(activityCategory, "activityCategory");
    }
      
    onNavigate = (path) => {
        const { navigate, location } = this.props;

        const targetPath = `/${path}`;
        // Only navigate if we aren’t already there
        if (location.pathname !== targetPath) {
            navigate(`/${path}`, { replace: true });
        }
    };
     
    render(){
            
    return <>
        <div className="container-fluid ">
            <div className="row w-100 mx-0" style={{ flexWrap: 'nowrap' }}>
                <div className="col-fixed mt-5">
                    <div className="mt-5">
                        <img className="train-track-img" src={'./assets/ExtraCredit.png'} 
                            alt="MoneyTrain"/>
                    </div>
                </div>
                <div>
                    <Tooltip title={tooltipCommentIconText} arrow >
                        <img src={this.state.commentIcon} 
                            className="activity-comment-icon-position comment-img cursor-is-pointer" 
                            alt="comment"
                            onClick={this.openCommentModal}/>
                    </Tooltip>
                </div> 


                {this.state.commentModalOpen ?
                    <CommentModal modalOpen={this.state.commentModalOpen} 
                        onClose={() => this.closeCommentModal()}
                        gamePart={this.state.fromProcessName}
                        processName={this.props.selected}
                        gameInfo = {() => this.getActivityInfo()}
                        processError = {(errorObj) => this.processErrorReturn(errorObj)}
                    />
                :
                    null
                }
                {this.props.selected === "selectActivity" ? 
                <SelectActivity
                    onOpen ={()=> this.inputSelected(0)}
                    onClose={()=>this.backToGameBoard()}
                    activityInfo = {() => this.getActivityInfo()} 
                    onComplete={() => this.inputCompleted(0)}
                    onNavigate={(pathname) => this.onNavigate(pathname)}
                    setActivityInfo = {(value, propertyName) => this.setActivityInfo(value, propertyName)}
                    processError = {(errorObj) => this.processErrorReturn(errorObj)}
                /> 
                : null}
                    {this.props.selected === "chooseAFriend" ? 
                <SelectFriendForActivity
                    onOpen ={()=> this.inputSelected(1)}
                    onClose={()=>this.backToGameBoard()}
                    activityInfo = {() => this.getActivityInfo()} 
                    onComplete={() => this.inputCompleted(1)}
                    onNavigate={(pathname) => this.onNavigate(pathname)}
                    setActivityInfo = {(value, propertyName) => this.setActivityInfo(value, propertyName)}
                    processError = {(errorObj) => this.processErrorReturn(errorObj)}
                /> 
                : null} 
                {this.props.selected === "startActivity" ? 
                <StartActivity
                    screenSize = {this.state.screenSize}
                    onOpen ={()=> this.inputSelected(2)}
                    onClose={()=>this.backToGameBoard()}
                    activityInfo = {() => this.getActivityInfo()} 
                    onComplete={() => this.inputCompleted(2)}
                    onNavigate={(pathname) => this.onNavigate(pathname)}
                    setActivityInfo = {(value, propertyName) => this.setActivityInfo(value, propertyName)}
                    processError = {(errorObj) => this.processErrorReturn(errorObj)}
                /> 
                : null} 
                    {this.props.selected === "finishActivity" ? 
                <FinishActivity
                    onOpen ={()=> this.inputSelected(3)}
                    onClose={()=>this.backToGameBoard()}
                    activityInfo = {() => this.getActivityInfo()} 
                    onComplete={() => this.inputCompleted(3)}
                    onNavigate={(pathname) => this.onNavigate(pathname)}
                    setActivityInfo = {(value, propertyName) => this.setActivityInfo(value, propertyName)}
                    processError = {(errorObj) => this.processErrorReturn(errorObj)}
                /> 
                : null} 
                     
                <div className="col-fixed mt-5 mx-4"> 
                    {this.state.activityInfo.activityStarted ?  
                        <LinkTab inputArr={this.state.inputArr[0]} name="Select Activity"
                             />
                    :
                        <Link to="/select-activity" onClick={() => this.handleClick(0)}>
                            <LinkTab inputArr={this.state.inputArr[0]} name="Select Activity" 
                                validToComplete={true}
                            />
                        </Link>
                    }
            
                    {this.state.activityCategory !== "SideHustle" ?
                        <div>
                            {this.state.inputArr[0].completed && !this.state.activityInfo.activityStarted ?
                                <Link to="/choose-a-friend" onClick={() => this.handleClick(1)}>
                                    <LinkTab inputArr={this.state.inputArr[1]} name="Choose a Friend" 
                                        validToComplete={true}
                                        />
                                </Link>
                                :
                                <LinkTab inputArr={this.state.inputArr[1]} name="Choose a Friend"  />
                            }
                        </div>
                    :
                        null
                    }

                    {!this.state.inputArr[2].completed &&
                        (this.state.inputArr[1].completed ||
                        (this.state.inputArr[0].completed === true && 
                            this.state.activityCategory === "SideHustle"))  ?
                        <Link to="/start-activity" onClick={() => this.handleClick(2)}>
                            <LinkTab inputArr={this.state.inputArr[2]} name="Start Activity" 
                                validToComplete={true}
                            />
                        </Link>
                    :
                        <LinkTab inputArr={this.state.inputArr[2]} name="Start Activity"  />
                    }

                    {this.state.inputArr[2].completed ?
                        <div>
                            <LinkTab inputArr={this.state.inputArr[3]} name="Finish Activity" 
                                tooltip="true"
                                tooltipText="Click the 'Finish' button that is to the left
                                    (in the bedroom picture)."
                                validToComplete={true} 
                                />
                        
                        </div>
                            
                    :
                        <LinkTab inputArr={this.state.inputArr[3]} name="Finish Activity" />
                    }

                    {(this.state.screenSize === "zoom") &&
                        <Footer 
                            screenSize={this.state.screenSize}
                        />
                    }
                </div>     
            </div>
 {/*   
             {process.env.NODE_ENV === 'development' && (
                        <div className="breakpoint-indicator" />
                        )}
*/}
    
        </div>             
    </>
}

    componentDidMount(){
        this._isMounted = true;
        this.className = "mt-5 mx-3";
        this.setState({activityCategory: this.props.activityCategory.detail})
    }

     inputSelected = (inputID) => {
        let inputArr = this.state.inputArr;
        for (const input of inputArr) {
            input.selected = false;
        }
        inputArr[inputID].selected = true;
        if (this._isMounted === true){
            this.setState({inputArr: inputArr});  
        }
        
    };
     
    inputCompleted = (inputID) => {
        let inputArr = this.state.inputArr;
        inputArr[inputID].completed = true;
        if (this._isMounted === true){
            this.setState({inputArr: inputArr}); 
        }
    };

    backToGameBoard(){
        this.onNavigate("game-board");
    }

    openCommentModal(){
        this.setState({commentModalOpen: true});
    }

    closeCommentModal(){
        this.setState({commentModalOpen: false});
    }

    handleClick = index => {
        this.inputSelected(index);
    }
  
    getActivityInfo()
    {
        return this.state.activityInfo;
    }

    setActivityInfo(value, propertyName = null)
    {
        if (propertyName)
        {
            let activityInfo = this.state.activityInfo;
            activityInfo[propertyName] = value;
            if (this._isMounted === true){
                this.setState({activityInfo: activityInfo});
            }
        }
        else this.setState({activityInfo: value});
    }

    processErrorReturn(errorObj){
        this.addRecordToLogfile(errorObj);
        if (!errorObj.silentAlert || errorObj.silentAlert === false){
            alert ("Uh oh!  Something unexpected has occurred " +
                "error has been logged and will be addressed. " +
                "For now click OK, then return to the process " +
                "where you were and try again.");
            this.onNavigate("");
        }
    }

    addRecordToLogfile(errorObj){
        const headers=setHeadersForFetch();  
        if (errorObj.status === 250){
            errorObj.message = "No record found";
        }
        if (!errorObj.errorObject){
            errorObj.errorObject = {};
        }
        const logFileBody =  {
            mainProcess: "Activities",
            subProcess: errorObj.subProcess,
            function: errorObj.function,
            status: errorObj.status,
            message: errorObj.message,
            errorObj: errorObj.errorObject
        };
        console.log("logFileBody is: ", logFileBody)
        const urlParm = "";
        const uri = buildUrl(this.state.environment, "saveLogFile", urlParm);
        fetch (uri,  
            {method:'POST',
                headers: headers,
                body: JSON.stringify(logFileBody)
            })
            .then(response => {
                if (response.ok){
                    response.json().then(data => {
                        const output = JSON.parse(data);
                        const statusCode = output.statusCode;
                        if (statusCode === 200){
                            console.log("logfile create was successful");
                        }else{
                            alert ("Response from save log file not valid!" +
                                " status is: " + statusCode +
                                " message is: " + output.body.message)
                            
                        }
                });
            }
        });
      
    }

}
export default  connect(mapStateToProps)(withRouterCompat(Activities));